import PropTypes from 'prop-types';
import React from 'react';

import InfoBox from './infoBox.component';

// Same red/green used by the Repay Agreement box on the authorization details header.
export const REPAY_AGREEMENT_STATUS = {
  NOT_REQUIRED: { label: 'Not Required', color: undefined },
  MISSING: { label: 'Missing', color: '#e2462b' },
  RECEIVED: { label: 'Received', color: '#26a84b' }
};

/**
 * Resolves the repay agreement status for an authorization.
 *
 * Whether an agreement is required comes from the relocation policy assigned to the
 * authorization (a client-level setting). When it is required, the agreement counts as
 * received only once both the sent and received dates are present on the authorization.
 *
 * @param {object} authorizationDetails - authorizationDetails from the authorization summary
 * @param {Array} clientRelocationPolicies - clientRelocationPolicies from the client details
 */
export const getRepayAgreementStatus = (authorizationDetails, clientRelocationPolicies) => {
  const relocationPolicyId = authorizationDetails?.relocationPolicyId;
  const policy = (clientRelocationPolicies ?? []).find(option => option?.policy?.relocationPolicyId === relocationPolicyId)?.policy;

  if (!policy?.isRepayAgreementRequired) {
    return REPAY_AGREEMENT_STATUS.NOT_REQUIRED;
  }

  const isReceived = !!authorizationDetails?.repayAgreementSent && !!authorizationDetails?.repayAgreementReceived;
  return isReceived ? REPAY_AGREEMENT_STATUS.RECEIVED : REPAY_AGREEMENT_STATUS.MISSING;
};

const RepayAgreementInfoBox = ({ authorizationDetails, clientRelocationPolicies }) => {
  const status = getRepayAgreementStatus(authorizationDetails, clientRelocationPolicies);
  return <InfoBox label="Repay Agreement" value={status.label} valueColor={status.color} />;
};

RepayAgreementInfoBox.propTypes = {
  authorizationDetails: PropTypes.shape({
    relocationPolicyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    repayAgreementSent: PropTypes.string,
    repayAgreementReceived: PropTypes.string
  }),
  clientRelocationPolicies: PropTypes.arrayOf(
    PropTypes.shape({
      policy: PropTypes.shape({
        relocationPolicyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        isRepayAgreementRequired: PropTypes.bool
      })
    })
  )
};

export default RepayAgreementInfoBox;
